import { MapPin, Clock, Phone, CheckCircle, Gift, Calendar, Store, Globe, Building2, Shield, Download, ExternalLink } from "lucide-react";

export const DetailRow = ({ label, value, valueColor = "text-slate-800", icon: Icon }) => (
  <div className="flex items-center justify-between py-2.5 border-b border-slate-100 last:border-0">
    <span className="text-sm text-slate-500 flex items-center gap-1.5">
      {Icon && <Icon className="w-3.5 h-3.5" />}{label}
    </span>
    <span className={`text-sm font-medium ${valueColor} text-right max-w-[55%]`}>{value}</span>
  </div>
);

export const humanize = (s) => {
  if (!s || typeof s !== "string") return s || "—";
  return s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};

export const getMapUrl = (name) => {
  const q = encodeURIComponent(`${name} locations`);
  return `https://www.google.com/maps/search/${q}`;
};
